export default "__VITE_ASSET__38dc9ebd__"